import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('กรุณากรอกชื่อแคมเปญ'),
  csvFile: Yup.string().required('กรุณาเลือกไฟล์'),
})
